import { render } from "./SabhaSignatures.vue?vue&type=template&id=156fcd9a&scoped=true"
import script from "./SabhaSignatures.vue?vue&type=script&lang=js"
export * from "./SabhaSignatures.vue?vue&type=script&lang=js"

import "./SabhaSignatures.vue?vue&type=style&index=0&id=156fcd9a&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-156fcd9a"]])

export default __exports__